import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { Portfolio } from "@/components/landing/Portfolio";
import { Metodo } from "@/components/landing/Metodo";
import { Estimator } from "@/components/landing/Estimator";
import { Pricing } from "@/components/landing/Pricing";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <main className="bg-[#09090B] text-zinc-50 font-jakarta grain">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <Metodo />
      <Estimator />
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
}
